webpackJsonp([46886381695165],{

/***/ 1138:
/***/ (function(module, exports) {

	module.exports = {"data":{"allContactFormJson":{"edges":[{"node":{"fieldname":"firstname","required":"true","type":"text","label":{"en":"First name:","es":"Nombre:"}}},{"node":{"fieldname":"lastname","required":null,"type":"text","label":{"en":"Last name:","es":"Apellidos:"}}},{"node":{"fieldname":"Subject","required":null,"type":"text","label":{"en":"Subject:","es":"Asunto:"}}},{"node":{"fieldname":"email","required":null,"type":"email","label":{"en":"E-mail:","es":"E-mail:"}}},{"node":{"fieldname":"message","required":null,"type":"textarea","label":{"en":"Message:","es":"Mensaje:"}}}]}},"pathContext":{"slug":"/en/contact/","langKey":"en"}}

/***/ })

});


// WEBPACK FOOTER //
// path---en-contact-25379672493b29570f34.js